import React from 'react';

import { useIntl } from 'react-intl';

import { IBackendCartEntries } from '@rbi-ctg/menu';
import Currency from 'components/currency';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { EnablePremiumComboSlotsVariations } from 'state/launchdarkly/variations';
import priceForCartEntry from 'utils/menu/price-for-cart-entry';

import { ItemName, ItemPrice, ItemQuantityBadge } from './cart-entry.styled';
import resolveEntryChild from './resolve-entry-child';

interface ICartEntry {
  entry: IBackendCartEntries;
  index?: number;
}

const CartEntry = ({ entry, index }: ICartEntry) => {
  const { formatMessage } = useIntl();
  const enablePremiumComboSlotsVariation = useFlag<EnablePremiumComboSlotsVariations>(
    LaunchDarklyFlag.ENABLE_PREMIUM_COMBO_SLOTS
  );
  const enableShowAllPrices =
    enablePremiumComboSlotsVariation !== EnablePremiumComboSlotsVariations.NONE;

  const row = (index ?? 0) + 1;

  return (
    <>
      <ItemQuantityBadge quantityText={formatMessage({ id: 'qty' })} row={row}>
        {entry.quantity || 1}
      </ItemQuantityBadge>
      <ItemName row={row}>
        {entry.name} {resolveEntryChild(entry, enableShowAllPrices)}
      </ItemName>
      <ItemPrice row={row}>
        <Currency amount={priceForCartEntry(entry)} />
      </ItemPrice>
    </>
  );
};

export default CartEntry;
